import { FC } from "react";
import { Font, Row } from "../../../TrueUI";
import { rowWithNoMarginNorGutter } from "../../../TrueUI/Grids/Row";

const SuccessBody: FC = () => {
  return (
    <Row
      {...rowWithNoMarginNorGutter}
      rowDirection="column"
      verticalAlign="flex-start"
    >
      <Font textAlign="start" whiteSpace="normal">
        This policy has been bound successfully.
      </Font>
      <br />
      <Font textAlign="start" whiteSpace="normal">
        The quote is now in an issued status and can no longer be edited.
      </Font>
      <br />
      <Font textAlign="start" whiteSpace="normal">
        Click on the Continue button to close this modal and return to the quote
        to print documents or enter notes.
      </Font>
      <br />
      <Font textAlign="start" whiteSpace="normal">
        Click on the Close Quote button to close this modal and the quote
        completely.
      </Font>
    </Row>
  );
};
export default SuccessBody;
